<template>
  <div class="polygon-overlay" :class="{'polygon-overlay--filtered': filtered}">
     <svg
      viewBox="0 0 3190 1960"
      height="98rem"
      width="159.5rem"
      :fill="polygon.fill"
      :stroke="polygon.stroke"
      :stroke-width="polygon.strokeWidth"
    >
      <polygon
        :class="{ 'drop-shadow': polygon.dropShadow }"
        :points="pointToPolygon"
        @click="navigationTo($event)"
      />
    </svg> 
  </div>
</template>

<script>
export default {
  props: {
    'polygon': {
      type: Object,
      default: () => ({
        fill: '#232323',
        stroke: '#ffffff',
        strokeWidth: 8,
        points: [],
        dropShadow: false,
      })
    },

    'fill': {
      type: String,
      default: '#23232350'
    },
    'stroke': { 
      type: String,
      default: '#ffffff'
    },
    'stroke-width': { 
      type: Number,
      default: 8
    },
    'points': {
      type: Array,
      default: () => []
    },
    'dropShadow': {
      type: Boolean,
      default: false
    },
    'to': {
      type: String,
      default: ''
    },
    filtered: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    pointToPolygon () {
      return this.polygon.points.map(point => `${point[0]},${point[1]}`).join(' ')
    }
  },

  methods: {
    navigationTo (e) {
      if (this.to) {
        e.stopPropagation()
        this.$router.push(this.to)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.polygon-overlay {
  pointer-events: none;
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  z-index: var(--polygon-z-index);

  svg polygon {
    pointer-events: auto;
  }

  .drop-shadow {
    filter: drop-shadow(10px 10px 10px #000);
  }

  &--filtered {
    filter: grayscale(100%);
    opacity: 0.5;
  }
}
</style>